<script setup lang="ts">
import { AppInput } from '@shared/ui/inputs'

import {
  useInputProductDislikeLink,
} from '../../../../model/additional-info/success/info-success-bad-feedback/input-product-dislike-link.hook'

defineOptions({
  name: 'InputProductDislikeLink',
})

const {
  inputType,
  model,
  placeholder,
} = useInputProductDislikeLink()
</script>

<template>
  <AppInput
    v-model="model"
    :type="inputType"
    :placeholder="placeholder"
  />
</template>
